import React from 'react';
import styles from './SwapCalculator.module.scss';
import { TokenIcon } from '@/components/elements/TokenIcon';
import { animated } from '@react-spring/web';

export interface TokenOption {
  name: string;
  mintAddress: string;
  icon?: string;
  symbol?: string;
  decimals: number;
  verified?: boolean;
  price?: number;
}

interface TokenDropdownProps {
  tokens: TokenOption[];
  selectedToken: TokenOption;
  onSelect: (token: TokenOption) => void;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
  transition: any;
  label?: string;
  symbolMap?: Record<string, string>;
  className?: string;
}

const TokenDropdown: React.FC<TokenDropdownProps> = ({
  tokens,
  selectedToken,
  onSelect,
  open,
  onOpen,
  onClose,
  dropdownRef,
  transition,
  label,
  symbolMap = {},
  className = '',
}) => {
  return (
    <div
      className={styles.swapCalcDropdown + (open ? ' ' + styles.open : '') + (className ? ' ' + className : '')}
      onClick={onOpen}
    >
      {selectedToken.icon && <TokenIcon src={selectedToken.icon} alt={selectedToken.name} verified={selectedToken.verified} />}
      <span className={styles.swapCalcDropdownLabel}>{selectedToken.symbol || selectedToken.name}</span>
      <img src="/tkn_lnd_pg_assets/images/icons/chevron-down.svg" alt="dropdown" width={16} height={16} className={styles.swapCalcDropdownIcon} />
      <div ref={dropdownRef}>
        {open &&
          transition((style: any, show: boolean) =>
            show ? (
              <animated.div style={style} className={styles.swapCalcDropdownListFullWidth}>
                {tokens.map(token => (
                  <div key={token.mintAddress} className={styles.swapCalcDropdownItem} onClick={e => { e.stopPropagation(); onSelect(token); onClose(); }}>
                    {token.icon && <TokenIcon src={token.icon} alt={token.name} />}
                    <span className={styles.swapCalcDropdownTokenName}>{token.name}</span>
                    {symbolMap[token.mintAddress] && (
                      <span className={styles.swapCalcDropdownTokenSymbol}>{symbolMap[token.mintAddress]}</span>
                    )}
                  </div>
                ))}
              </animated.div>
            ) : null
          )

        }</div>
    </div>
  );
};

export default TokenDropdown; 